import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function StatusStrip() {
  return <section id="status" className="w-full scroll-mt-20 border-b border-mist bg-white/50" data-id="element-404" data-mp="yr4zyj8vqmhc">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-10 lg:flex-row lg:items-center lg:justify-between lg:px-10" data-id="element-405" data-mp="urw6lfhr4qmb">
        <div data-id="element-406" data-mp="puctiiwsijvy">
          <p className="max-w-[64ch] text-lg leading-relaxed text-ink" data-id="element-407" data-mp="1mi9avq01xj88">
            Lentic is early, and specific about it. The mechanic runs end to
            end; predictive validity is a longer-term question we are not yet
            claiming.
          </p>
        </div>
        <Link to="/company" className="inline-flex shrink-0 items-center gap-2 rounded-full border border-ink/15 px-6 py-3.5 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-408" data-mp="1dnummxxjmycz">
          What we've proven, and what we haven't
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-409" data-mp="21dys7aual86m" />
        </Link>
      </div>
    </section>;
}